import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BriefcaseCollection } from '../models/ui/briefcase-collection.model';
import { BriefcaseJobSdk } from '../sdks/briefcase-job.sdk';
import { Briefcase } from '../models/ui/briefcase.model';
import { FileRecord } from '../models/ui/file.model';
import {BriefcaseJob} from "@models/review/briefcase-job.model";

@Injectable({
	providedIn: 'root'
})
export class BriefcaseManager {
	public briefcaseCollection$: Observable<BriefcaseCollection>;
	public currentBriefcase$: Observable<Briefcase>;

	private briefcaseCollectionSource: BehaviorSubject<BriefcaseCollection> = new BehaviorSubject<BriefcaseCollection>(null);
	private currentBriefcaseSource: BehaviorSubject<Briefcase> = new BehaviorSubject<Briefcase>(null);

	constructor(private briefcaseJobSdk: BriefcaseJobSdk) {
		this.briefcaseCollection$ = this.briefcaseCollectionSource.asObservable();
		this.currentBriefcase$ = this.currentBriefcaseSource.asObservable();
	}

	public refreshBriefcases(params: RefreshBriefcasesParams): void {
		this.briefcaseJobSdk.get({
			skip: params?.skip,
			top: params?.take
		}).subscribe((response) => this.briefcaseCollectionSource.next(response));
	}

	public setCurrentBriefcase(id: string): void {
		this.briefcaseJobSdk.get({ id }).subscribe((response) => this.currentBriefcaseSource.next(response.items[0]));
	}

	public removeBriefcase(id: string): Observable<void> {
		return this.briefcaseJobSdk.delete({ id });
	}

	public saveBriefcase(briefcase: Briefcase): Observable<void> {
		return this.briefcaseJobSdk.put({ briefcase });
	}

	public downloadBriefcaseFile(file: FileRecord): Observable<string> {
		return this.briefcaseJobSdk.download({ file });
	}

	public createBriefcaseFile(id: string, type: 'outgoing-briefcase-pdf-merged' | 'outgoing-briefcase-zipped'): Observable<any> {
		return this.briefcaseJobSdk.createFile({ id, type });
	}

	public createBriefcase(briefcaseJob: BriefcaseJob): Observable<any> {
		return this.briefcaseJobSdk.createBriefcase(briefcaseJob);
	}

	public getFileList(id: string): Observable<FileRecord[]> {
		return this.briefcaseJobSdk.getFileList({
			id
		});
	}
}

interface RefreshBriefcasesParams {
	skip: number;
	take: number;
}
